import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { EmailFooter } from 'src/app/models/email-footer';
import { CKEditorComponent } from '@ckeditor/ckeditor5-angular';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CkeditorUploadService } from 'src/app/services/ckeditor-upload.service';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'wm-email-footer-editor',
    templateUrl: './email-footer-editor.component.html',
    styleUrl: './email-footer-editor.component.css',
    standalone: false
})
export class EmailFooterEditorComponent implements OnInit, OnDestroy {
  @Input() emailFooter: EmailFooter;
  @Input() form: UntypedFormGroup;

  @ViewChild('htmlContentEditor', { static: false }) htmlContentEditor: CKEditorComponent;

  faTimes = faTimes;
  public Editor = ClassicEditor;
  public editorConfig = {
    toolbar: [
      'heading',
      '|',
      'bold',
      'italic',
      'link',
      '|',
      'bulletedList',
      'numberedList',
      'imageUpload',
      '|',
      'undo',
      'redo'
    ]
  };

  constructor (
    private _fb: UntypedFormBuilder,
    private _uploadAdapter: CkeditorUploadService
  ) { }

  ngOnInit() {
    this.form.addControl('label', this._fb.control('', [Validators.required]));
    this.form.addControl('enabled', this._fb.control('', [Validators.nullValidator]));
    this.form.addControl('htmlContent', this._fb.control('', [Validators.required]));
  }

  ngOnDestroy() {
    this.form.removeControl('label');
    this.form.removeControl('enabled');
    this.form.removeControl('htmlContent');
  }

  public editorReady(editor) {
    const parentId: string = this.emailFooter.id;
    editor.plugins.get('FileRepository').createUploadAdapter = loader => {
      this._uploadAdapter.setLoader(loader, parentId);

      this._uploadAdapter.loader = loader;

      this._uploadAdapter.isUploading.subscribe((isUploading: boolean) => {
        if (this.form.controls['htmlContent-IS_UPLOADING']) {
          this.form.controls['$htmlContent-IS_UPLOADING'].setValue(
            isUploading ? 1 : 0
          );
        }
      });

      return this._uploadAdapter;
    };
  }
}
